import React from 'react';
import '../../assets/styles/user_page.scss';
import Skeleton from 'react-skeleton-loader';
import { Colors } from '../../constants';
import useWindowDimensions from '../../custom_hooks/useWindowDimensions';
import { hex_to_rgba } from '../../custom_functions/hex_to_rgba';

const LoadingPageView = () => {
  const { width } = useWindowDimensions();

  return(
    <div className="user-page">
      <div className="container">

        <div className="left" style={{backgroundColor:'#F6F5F8', boxShadow: `inset -1.063rem 0 1.25rem 0 ${hex_to_rgba('#F6F5F8', 0.05)}`}}>
          <div className="section-top">
            <div className="photo">
                <Skeleton width={`${width <= 858 ? '2' : '5'}rem`} height={`${width <= 858 ? '2' : '5'}rem`} color={`#${Colors.lightGray}`} borderRadius={`${width <= 858 ? '.5' : '.625'}rem`} widthRandomness={0} heightRandomness={0} />
            </div>
            <div className="name">
              <div className={"loading-page-wrap"}>
                  <Skeleton width={"150px"} height={"15px"} color={`#${Colors.lightGray}`} widthRandomness={0} heightRandomness={0} />
              </div>
            </div>
          </div>

          <div className="section-bottom">
            <div className="description-wrap">
                <div className={"loading-page-wrap"}>
                    <Skeleton width={"200px"} height={"15px"} color={`#${Colors.lightGray}`} widthRandomness={0} heightRandomness={0} />
                </div>
                <div className={"loading-page-wrap"}>
                    <Skeleton width={"150px"} height={"15px"} color={`#${Colors.lightGray}`} widthRandomness={0} heightRandomness={0} />
                </div>
                <div className={"loading-page-wrap"}>
                    <Skeleton width={"100px"} height={"15px"} color={`#${Colors.lightGray}`} widthRandomness={0} heightRandomness={0} />
                </div>
            </div>
          </div>
        </div>

        <div className="right-content" style={{ height: '100%' }}>
          <div className="content-wrap-overflow">
            <div className="user-content-wrap">
              <div className="header">
                <Skeleton width={"200px"} height={"15px"} color={"#dedede"} widthRandomness={0} heightRandomness={0} style={{ margin: 'auto', display: 'block' }} />
              </div>
            </div>

            <div className="user-content-wrap">
              <div className="displayed-meetings">
                <ItemLoadingMeetings />
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

const ItemLoadingMeetings = () => {
  let items = [];
  let rows = [];
  const { width } = useWindowDimensions();
  let num = 6;
  if(width < 426){
    num = 2;
  }

  for(var i=0; i<num; i++){
    items.push(
      <div className={`content-link ${(i+1)%2 === 0 ? 'm-left' : ''}`} key={i} style={{ width: '9.6rem'}}>
        <div className="content-item">
          <div className="item-wrap">
            <div className="content-text bold-text displayed-name-text">
              <Skeleton width={"100px"} height={"15px"} color={"#dedede"} widthRandomness={0} heightRandomness={0} />
            </div>
          </div>
          <div className="item-wrap">
            <div className="content-text text-margin-left">
              <Skeleton width={"80px"} height={"15px"} color={"#dedede"} widthRandomness={0} heightRandomness={0} />
            </div>
          </div>
          <div className="item-wrap">
            <div className="content-text text-margin-left">
            <Skeleton width={"60px"} height={"15px"} color={"#dedede"} widthRandomness={0} heightRandomness={0} />
            </div>
          </div>
        </div>
      </div>
    );

    if((i+1)%2 === 0 || (num.length-1) === i){
      rows.push(
        <div className="row" key={`row-${i+1}`}>
          {items}
        </div>
      );
      items = [];
    }
  }
  return rows;
}

export default LoadingPageView;